export default __webpack_public_path__ + "static/media/sql.29e4bfa7.png";